const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";

// Admin Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Admin",
      description: "Page title"
    }),
    textOnlyBreadcrumbsSegment: true
  }
});